import { SEVERITY } from '../constants';
function ConsoleLoggerEngine() {
    return {
        init: () => {
            // Empty
        },
        log: ({ level, message, context }) => {
            const logLevel = level ? `${level === null || level === void 0 ? void 0 : level.toUpperCase()}:` : "";
            switch (level) {
                case SEVERITY.fatal:
                case SEVERITY.error:
                    console.error(logLevel, message, context);
                    break;
                case SEVERITY.info:
                    console.info(logLevel, message, context);
                    break;
                default:
                    console.log(logLevel, message, context);
            }
            console.log(message, context);
        },
        logException: (exception, context) => {
            console.error(exception, context);
        },
        setUser: (user) => {
            console.log(`Set User: ${user}`);
        },
        clearUser: () => {
            // Empty
        },
        setTag: () => {
            // Empty
        },
        setTags: (tags) => {
            console.log(`Set Tags:`, tags);
        },
        setContext: (name, ctx) => {
            console.log(`Set Context: ${name}`, ctx);
        },
    };
}
export default ConsoleLoggerEngine;
//# sourceMappingURL=console-logger-engine.js.map